import React, { useEffect, useRef } from "react";
import { Marker, Polyline, useMap } from "react-leaflet";
import L from "leaflet";
import { statusIcons, createMarkerIcon } from "./mapUtils";

export default function MapMarkers({
  receipts = [],
  showFullRoute,
  onMarkerClick,
  selectedReceipt,
}) {
  const map = useMap();
  const markerRefs = useRef({});

  // Центровка карты на выбранный маркер
  useEffect(() => {
    if (!selectedReceipt) return;
    const ref = markerRefs.current[selectedReceipt.id];
    if (ref && ref.getLatLng) {
      map.flyTo(ref.getLatLng(), map.getZoom(), { duration: 0.6 });
    }
  }, [selectedReceipt, map]);

  // Формируем маршрут
  const routePath = receipts
    .filter((r) => r.latitude && r.longitude)
    .sort(
      (a, b) => new Date(a.status_changed_at) - new Date(b.status_changed_at)
    )
    .map((r) => [r.latitude, r.longitude]);

  // === 🔵 Иконка-подсветка для выбранной точки ===
  const pulseIcon = L.divIcon({
    className: "",
    html: `
      <div style="
        position: absolute;
        top: 50%;
        left: 50%;
        width: 38px;
        height: 38px;
        border-radius: 50%;
        background: rgba(74,108,247,0.25);
        border: 3px solid #4a6cf7;
        box-shadow: 0 0 20px 6px rgba(74,108,247,0.5);
        transform: translate(-50%, -50%);
        animation: pulseMarker 1.5s infinite ease-in-out;
      "></div>

      <style>
        @keyframes pulseMarker {
          0%   { transform: translate(-50%, -50%) scale(0.9); opacity: 0.9; }
          50%  { transform: translate(-50%, -50%) scale(1.4); opacity: 0.5; }
          100% { transform: translate(-50%, -50%) scale(0.9); opacity: 0.9; }
        }
      </style>
    `,
    iconSize: [38, 38],
    iconAnchor: [19, 19],
  });

  return (
    <>
      {showFullRoute && routePath.length > 1 && (
        <Polyline
          positions={routePath}
          pathOptions={{ color: "#4a6cf7", dashArray: "5" }}
        />
      )}

      {receipts.map((r) => {
        const icon = createMarkerIcon(statusIcons[r.status]);
        const isSelected = selectedReceipt?.id === r.id;

        return (
          <React.Fragment key={r.id}>
            {/* Пульсирующее кольцо-подсветка */}
            {isSelected && (
              <Marker
                position={[r.latitude, r.longitude]}
                icon={pulseIcon}
                interactive={false}
                zIndexOffset={-1000} // чтобы не перекрывал основной маркер
              />
            )}

            {/* Сам маркер */}
            <Marker
              position={[r.latitude, r.longitude]}
              icon={icon}
              ref={(el) => (markerRefs.current[r.id] = el)}
              eventHandlers={{
                click: () => onMarkerClick?.(r),
              }}
            />
          </React.Fragment>
        );
      })}
    </>
  );
}
